const agentMainDataActions = {
  AGENT_MAIN_DATA_INIT: 'AGENT_MAIN_DATA_INIT',
  AGENT_MAIN_DATA_SET: 'AGENT_MAIN_DATA_SET',
  AGENT_MAIN_DATA_PROP_SET: 'AGENT_MAIN_DATA_PROP_SET'
};
export default agentMainDataActions;
